import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK } from '@/features/constants';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { MeteringPointConnectionType } from './types';

export const meteringPointConnectionTypesApi = createApi({
  reducerPath: 'meteringPointConnectionTypesApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/connection-types`,
  }),
  keepUnusedDataFor: CACHE_EXPIRATION_TIME_REFERENCE_BOOK,
  endpoints: builder => ({
    getMeteringPointConnectionTypes: builder.query<
      MeteringPointConnectionType[],
      void
    >({
      query: () => ({
        url: '',
      }),
    }),
  }),
});

export const { useGetMeteringPointConnectionTypesQuery } =
  meteringPointConnectionTypesApi;
